module.exports = "<div class=\"matero-progress-bar\"\r\n     [ngStyle]=\"{ 'width.%': value, 'background-color': foreground }\">\r\n</div>"